// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingWheel_wrapper__XfQdI","rotate":"LoadingWheel_rotate__1mt6v"};